import {lazy} from "react";

export const ReportScheduleExecutionByRoutesLazy = lazy(()=>import('./ReportScheduleExecutionByRoutes'))